import React, { ReactNode, useEffect, useRef, useState } from "react";

import "./ConditionDelayClose.scss";

interface IConditionDelayCloseProps {
	check: boolean;
	delayTime: number;
	children: ReactNode;
}

const ConditionDelayClose: React.FC<IConditionDelayCloseProps> = ({
	check,
	delayTime,
	children,
}) => {
	const [shouldRender, setShouldRender] = useState(check);
	const [isVisible, setIsVisible] = useState(check);
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);
	const fadeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		const clearAllTimers = () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
				timeoutRef.current = null;
			}
			if (fadeTimeoutRef.current) {
				clearTimeout(fadeTimeoutRef.current);
				fadeTimeoutRef.current = null;
			}
		};

		if (check) {
			clearAllTimers();
			setShouldRender(true);
			setIsVisible(true);
		} else {
			clearAllTimers();

			// Only start fade sequence if delayTime is greater than fade duration (1000ms)
			if (delayTime > 1000) {
				fadeTimeoutRef.current = setTimeout(() => {
					setIsVisible(false);
					timeoutRef.current = setTimeout(() => {
						setShouldRender(false);
					}, 1000);
				}, delayTime - 1000);
			} else {
				// If delayTime is too short, just fade immediately
				setIsVisible(false);
				timeoutRef.current = setTimeout(() => {
					setShouldRender(false);
				}, delayTime);
			}
		}

		return () => {
			clearAllTimers();
		};
	}, [check, delayTime]);

	if (!shouldRender) {
		return <>{children}</>;
	}

	const loadingCoverClass = `LoadingCover ${isVisible ? "LoadingCover--visible" : "LoadingCover--hidden"}`;

	return (
		<>
			<div className={loadingCoverClass}>
				<div className="LoadingSpinner" />
			</div>
			{children}
		</>
	);
};

export default ConditionDelayClose;
